import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';

import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';

import BusinessModelSectionEcosystemV2 from '../../../assets/landing/business-model/business-model-ecosystem-v2.png';

import styles from './LandingBusinessModelSection.module.scss';

const LandingBusinessModelSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <section className={['landing-page-container', styles['section']].join(' ')}>
      <ScrollInAnimationItem
        className={styles['ecosystem']}
        animationType={ScrollAnimationType.slideInTop}
        delay="0.1s"
        threshold={0.3}
      >
        {mainAnimationLoaded && <img src={BusinessModelSectionEcosystemV2} alt="" width="750" height="627" />}
      </ScrollInAnimationItem>
      <ScrollInAnimationItem className={styles['summary']} delay="0.2s">
        <h2>
          <b>sustainable business model</b> with constant demand
        </h2>
        <p className={`landing-main-text ${styles['paragraph']}`}>
          Our RMV token drives consistent demand by offering real utility—acquiring digital assets, forming
          partnerships, collaborating on 3D models, and earning royalties from multiple games.
        </p>
        <p className={`landing-main-text ${styles['paragraph']}`}>
          Additionally, external games using fiat currency to generate profits can convert them into RMV tokens, which
          are shared with asset owners, ensuring a continuous and growing ecosystem demand.
        </p>
      </ScrollInAnimationItem>
    </section>
  );
};

export default LandingBusinessModelSection;
